import React, {useState, useEffect} from 'react';
import './BaseNumber.css'

let BaseNumber = ({value, handleValueChange, className, numberType}) => {
    return (
        <div className = {className}>        
            <div className='number-type'>{numberType}</div>        
            <a className="btn-floating btn-small" onClick={() => handleValueChange(value - 1)}><i className="material-icons">keyboard_arrow_down</i></a>
            <span>{value}</span>
            <a className="btn-floating btn-small" onClick={() => handleValueChange(value + 1)}><i className="material-icons">keyboard_arrow_up</i></a>
        </div>
    );
}

export default BaseNumber;